// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Roboto", sans-serif
}

body{
    background-color: #E9ECEF;
}

.main{
    display: flex;
    width: 100%;
    height: 100%;
}

.main .left-container{
    display: flex;
    width: 26vw;
    height: 100vh;
    flex-direction: column;
    padding: 10px 10px;
    background-color: #DEE2E6;
}


.main .left-container .logo-heading{
    margin-bottom: 10px;
    display: inline-block;
    font-size: 50px;
}

.main .left-container .login-form{
    background-color: #E9ECEF;
    border-radius: 10px;
    margin-top: 30px;
    padding: 20px 20px;
    display: flex;
    flex-direction: column;
}

.login-form .notes-heading{
    margin-left: 10px;
    margin-bottom: 30px;
}

.main .left-container .name-heading{
    font-weight: 300;
    font-style: italic;
}

.login-form input[type='text']{
    margin: 10px 0px;
    padding: 5px 5px;
    outline: none; /* Removes default outline */
}

.login-form .form-select{
    margin: 10px 0px;
    padding: 5px 5px;    
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px; 
    flex-direction: column;
}

.form-group .required {
    color: red; 
    margin-right: 5px;
    font-size: 18px; 
}

.form-group input[type="text"] {
    flex: 1 1; /* Allow the input box to take up remaining space */
    padding: 5px; /* Adjust padding inside the input box if needed */
    font-size: 14px; /* Adjust the size of the input text if needed */
    width: 100%;
}

.login-form button[type='submit']{
    margin: 10px 0px;
    padding: 5px 5px;        
}

.login-form button[type='submit']:hover{
    cursor: pointer;
}

.main .left-container .logo-x{
    color: red;
}

/* home.css */
.main {
    display: flex;
    justify-content: space-between;
}

.logo-heading {
    font-size: 2em;
    font-weight: bold;
}

.login-form label{
    font-size: 16px;
    margin-right: 5px;
}

.login-form .required {
    color: red; /* Adjust the color if needed */
    margin-left: 2px; /* Adjust spacing if needed */
}

.right-container{
    margin-top: 10px;
    width: 74vw;
    background-color: #E9ECEF;
}

.right{
    background-color: #E9ECEF;
}

.right-container ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: start;
    /* justify-content: space-around; */
    background-color: #F8F9FA;

}

.right-container ul li {
    padding: 10px 20px;
    cursor: pointer;
    color: #343A40;
    text-transform: uppercase;
    font-weight: bold;
}

.right-container ul li:hover {
    background-color: #CED4DA;
}

.right-top .heading, .genrex{
    margin: 10px 10px;
}

.genrex-head{
    margin: 5px 5px;
}

.right-top .heading .name-heading{
    letter-spacing: 7px;
    text-transform: uppercase;
    margin: 5px 5px;

}

.right-top .heading{
    margin-top: 70px;
}

.right-top .heading .logo-x{
    color: red;
}

.right-top .top-box{
    width: 70%;
    height: 40px;
    border-radius: 5px;
    background-color: #9ba3aa;
    padding: 10px 20px;
    margin-left: 80px;
    margin-top: 25px;
}

.right-top .top-box .insidebox{
    height: 15px;
    background-color: #DEE2E6;
    border-radius: 10px;
    margin: 2px;
}

.right-top .top-box .circle{
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: #DEE2E6;
}

.right-container ul li.active {
    font-weight: bold;
    background-color: #E9ECEF;
    color: #212529;
  }

  /* Tooltip container */
.initiative-input {
    position: relative;
    display: inline-block;
  }
  
  /* Tooltip text */
  .initiative-input::after {
    content: attr(title);
    visibility: hidden;
    width: 200px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* Position the tooltip above the input */
    left: 50%;
    margin-left: -100px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px; /* Adjust font size as needed */
  }
  
  /* Show the tooltip text when hovering over the input */
  .initiative-input:hover::after {
    visibility: visible;
    opacity: 1;
  }
  
.label-container{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;;AAGA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa,EAAE,4BAA4B;AAC/C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAO,EAAE,mDAAmD;IAC5D,YAAY,EAAE,kDAAkD;IAChE,eAAe,EAAE,gDAAgD;IACjE,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA,aAAa;AACb;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU,EAAE,+BAA+B;IAC3C,gBAAgB,EAAE,6BAA6B;AACnD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;EAChB;;EAEA,sBAAsB;AACxB;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,yCAAyC;IACvD,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,eAAe,EAAE,+BAA+B;EAClD;;EAEA,uDAAuD;EACvD;IACE,mBAAmB;IACnB,UAAU;EACZ;;AAEF;IACI,WAAW;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n*{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: \"Roboto\", sans-serif\n}\n\nbody{\n    background-color: #E9ECEF;\n}\n\n.main{\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n\n.main .left-container{\n    display: flex;\n    width: 26vw;\n    height: 100vh;\n    flex-direction: column;\n    padding: 10px 10px;\n    background-color: #DEE2E6;\n}\n\n\n.main .left-container .logo-heading{\n    margin-bottom: 10px;\n    display: inline-block;\n    font-size: 50px;\n}\n\n.main .left-container .login-form{\n    background-color: #E9ECEF;\n    border-radius: 10px;\n    margin-top: 30px;\n    padding: 20px 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.login-form .notes-heading{\n    margin-left: 10px;\n    margin-bottom: 30px;\n}\n\n.main .left-container .name-heading{\n    font-weight: 300;\n    font-style: italic;\n}\n\n.login-form input[type='text']{\n    margin: 10px 0px;\n    padding: 5px 5px;\n    outline: none; /* Removes default outline */\n}\n\n.login-form .form-select{\n    margin: 10px 0px;\n    padding: 5px 5px;    \n}\n\n.form-group {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px; \n    flex-direction: column;\n}\n\n.form-group .required {\n    color: red; \n    margin-right: 5px;\n    font-size: 18px; \n}\n\n.form-group input[type=\"text\"] {\n    flex: 1; /* Allow the input box to take up remaining space */\n    padding: 5px; /* Adjust padding inside the input box if needed */\n    font-size: 14px; /* Adjust the size of the input text if needed */\n    width: 100%;\n}\n\n.login-form button[type='submit']{\n    margin: 10px 0px;\n    padding: 5px 5px;        \n}\n\n.login-form button[type='submit']:hover{\n    cursor: pointer;\n}\n\n.main .left-container .logo-x{\n    color: red;\n}\n\n/* home.css */\n.main {\n    display: flex;\n    justify-content: space-between;\n}\n\n.logo-heading {\n    font-size: 2em;\n    font-weight: bold;\n}\n\n.login-form label{\n    font-size: 16px;\n    margin-right: 5px;\n}\n\n.login-form .required {\n    color: red; /* Adjust the color if needed */\n    margin-left: 2px; /* Adjust spacing if needed */\n}\n\n.right-container{\n    margin-top: 10px;\n    width: 74vw;\n    background-color: #E9ECEF;\n}\n\n.right{\n    background-color: #E9ECEF;\n}\n\n.right-container ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    justify-content: start;\n    /* justify-content: space-around; */\n    background-color: #F8F9FA;\n\n}\n\n.right-container ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    color: #343A40;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.right-container ul li:hover {\n    background-color: #CED4DA;\n}\n\n.right-top .heading, .genrex{\n    margin: 10px 10px;\n}\n\n.genrex-head{\n    margin: 5px 5px;\n}\n\n.right-top .heading .name-heading{\n    letter-spacing: 7px;\n    text-transform: uppercase;\n    margin: 5px 5px;\n\n}\n\n.right-top .heading{\n    margin-top: 70px;\n}\n\n.right-top .heading .logo-x{\n    color: red;\n}\n\n.right-top .top-box{\n    width: 70%;\n    height: 40px;\n    border-radius: 5px;\n    background-color: #9ba3aa;\n    padding: 10px 20px;\n    margin-left: 80px;\n    margin-top: 25px;\n}\n\n.right-top .top-box .insidebox{\n    height: 15px;\n    background-color: #DEE2E6;\n    border-radius: 10px;\n    margin: 2px;\n}\n\n.right-top .top-box .circle{\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n    background-color: #DEE2E6;\n}\n\n.right-container ul li.active {\n    font-weight: bold;\n    background-color: #E9ECEF;\n    color: #212529;\n  }\n\n  /* Tooltip container */\n.initiative-input {\n    position: relative;\n    display: inline-block;\n  }\n  \n  /* Tooltip text */\n  .initiative-input::after {\n    content: attr(title);\n    visibility: hidden;\n    width: 200px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%; /* Position the tooltip above the input */\n    left: 50%;\n    margin-left: -100px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    font-size: 12px; /* Adjust font size as needed */\n  }\n  \n  /* Show the tooltip text when hovering over the input */\n  .initiative-input:hover::after {\n    visibility: visible;\n    opacity: 1;\n  }\n  \n.label-container{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
